import React from 'react';
import { formatCurrency } from 'app/lib/utils/currency';
import { orZero } from 'app/lib/utils/NumUtils';

const landingPageTableHeader = (
    <div className="row header">
        <div className="col col-header page">
            <div className="title">
                Landing Pages
            </div>
        </div>

        <div className="col col-header revenue">
            <div className="title">
                Revenue
            </div>

            <div className="cols">
                <div className="cell title">
                    Revenue
                </div>
                <div className="cell title">
                    Orders
                </div>
                <div className="cell title">
                    AOV
                </div>
            </div>
        </div>

        <div className="col col-header page-value">
            <div className="title">
                Page Value
            </div>

            <div className="cols">
                <div className="cell title">
                    Shopper Sessions
                </div>
                <div className="cell title">
                    Revenue Per Shopper
                </div>
                <div className="cell title">
                    Conv. Rate
                </div>
            </div>
        </div>

        <div className="col col-header page-impact">
            <div className="title">
                Page Impact
            </div>

            <div className="cols">
                <div className="cell title">
                    % Of Shoppers
                </div>
                <div className="cell title">
                    % Of Revenue
                </div>
                <div className="cell title">
                    Impact
                </div>
            </div>
        </div>
    </div>
);

function LandingPageRow({ item, totals }) {
    const {
        revenue,
        orders,
        aov,
        sessions,
        scores
    } = item.totals;

    return (
        <div className="row data">
            <div className="row-data page">
                <div className="cell">
                    {item.name}
                </div>
            </div>

            <div className="row-data revenue">
                <div className="cell">
                    {formatCurrency(revenue, 2)}
                </div>
                <div className="cell">
                    {orders.toLocaleString('en-US')}
                </div>
                <div className="cell">
                    {formatCurrency(aov, 2)}
                </div>
            </div>

            <div className="row-data page-value">
                <div className="cell">
                    {sessions.toLocaleString('en-US')}
                </div>
                <div className="cell">
                    {formatCurrency(orZero((revenue / sessions).toFixed(2)), 2)}
                </div>
                <div className="cell">
                    {scores.conversionRate.toFixed(1)}%
                </div>
            </div>

            <div className="row-data page-impact">
                <div className="cell">
                    {orZero((sessions / totals.session))}%
                </div>
                <div className="cell">
                    {orZero((revenue / totals.revenue).toFixed(2))}%
                </div>
                <div className="cell">
                    {orZero((revenue / totals.revenue - sessions / totals.sessions).toFixed(2))}%
                </div>
            </div>
        </div>
    )
}

function LandingPageTable({ items, totals }) {
    const rows = items.map(item => <LandingPageRow key={item.id} item={item} totals={totals} />)

    return (
        <div className="scroll-content">
            {rows}
        </div>
    );
}

function LandingPageTableFooter({ numOfPages, totals }) {
    const { revenue, orders, aov, sessions, scores } = totals;

    return (
        <div className="row totals">
            <div className="col col-page-total">
                {`Total of ${numOfPages} Pages`}
            </div>

            <div className="col col-total revenue">
                <div className="cell data">
                    {formatCurrency(revenue, 2)}
                </div>
                <div className="cell data">
                    {orders.toLocaleString('en-US')}
                </div>
                <div className="cell data">
                    {formatCurrency(aov, 2)}
                </div>
            </div>

            <div className="col col-total page-value">
                <div className="cell data">
                    {sessions.toLocaleString('en-US')}
                </div>
                <div className="cell data">
                    {formatCurrency(orZero(revenue / sessions), 2)}
                </div>
                <div className="cell data">
                    {scores.conversionRate.toFixed(1)}%
                </div>
            </div>

            <div className="col col-total page-impact">
                <div className="cell data">
                    100%
                </div>
                <div className="cell data">
                    100%
                </div>
                <div className="cell data">
                    -
                </div>
            </div>
        </div>
    )
}

function LPManagerBody({ data, totals }) {
    return (
        <div className="page-body">
            <div className="container">
                {landingPageTableHeader}
                <LandingPageTable items={data} totals={totals} />
                <LandingPageTableFooter numOfPages={data.length} totals={totals} />
            </div>
        </div>
    );
}

export default LPManagerBody;